module.exports = __webpack_public_path__ + "static/media/agenda-1.a2aafce0.png";